addEventListener('DOMContentLoaded', function () {
    let parent = document.querySelector('.content-for-layout').querySelector('.rocket-gigis-white-page').querySelector('.gigi-white-page__container')
    let elAction = document.createElement('div');
    elAction.className = 'action-change-section';
    document.querySelectorAll('.action-title-white-pages').forEach((item, index)=> {
        if(index == 0) {
            item.classList.add('active')
            let idSectionActive = item.getAttribute('data-open');
            let elContent = document.getElementById(`${idSectionActive}`);
            document.querySelector('.gigi-white-page__content-fake').innerHTML = elContent.innerHTML;
            document.querySelector('.gigi-white-page__content-fake').classList.add('active')
        }
        item.classList.remove('hidden')
        elAction.appendChild(item);
        item.addEventListener('click', function () {
            openSection(item);
        })
    });

    parent.insertBefore(elAction, parent.firstChild);
    parent.classList.add('section-parent-faq');

    let elTitle = document.createElement('div');
    elTitle.className = 'faq-title';
    elTitle.innerHTML = window.faq.title;
    parent.insertBefore(elTitle, parent.firstChild);

    document.querySelector('.gigi-white-page__content-fake').querySelectorAll('.gigi-white-page__content__wrapper').forEach(item => {
        item.addEventListener('click', function () {
            openQuery(item);
        })
    });

    let elMedia = document.createElement('div');
    elMedia.className = 'faq-media';
    document.querySelectorAll('.gigi-image-w-text__container').forEach(item => {
        let elWrapMedia = document.createElement('div');
        elWrapMedia.className = 'faq-wrap-media';

        let elImage = document.createElement('div');
        elImage.className = 'faq-img-media'

        let mediaSection = item.querySelector('.gigi-media_container')
        elImage.appendChild(mediaSection);

        let elContent = document.createElement('div');
        elContent.className = 'faq-content';

        let contentSection = item.querySelector('.gigi-image-w-text__content-wrapper');
        elContent.appendChild(contentSection);

        elWrapMedia.appendChild(elImage)
        elWrapMedia.appendChild(elContent)
        elMedia.appendChild(elWrapMedia)
    });

    parent.appendChild(elMedia)


    function openQuery(el) {
        if(el.classList.contains('active')) {
            el.classList.remove('active');
        } else {
            if(document.querySelector('.gigi-white-page__content__wrapper.active')) {
                document.querySelector('.gigi-white-page__content__wrapper.active').classList.remove('active');
            }
            el.classList.add('active');
        }
    }

    function openSection(el) {
        if(document.querySelector('.action-title-white-pages.active')) {
            document.querySelector('.action-title-white-pages.active').classList.remove('active');
        }
        el.classList.add('active');
        let idSectionActive = el.getAttribute('data-open');
        let elContent = document.getElementById(`${idSectionActive}`);
        document.querySelector('.gigi-white-page__content-fake').innerHTML = elContent.innerHTML;
        document.querySelector('.gigi-white-page__content-fake').querySelectorAll('.gigi-white-page__content__wrapper').forEach(item => {
            item.addEventListener('click', function () {
                openQuery(item);
            })
        });
    }
})